import {
  Dropdown,
  Menu,
  Avatar,
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { userImplement } from '@/config/hooks/user';
import { ENV } from '@/infrastructure/env-config';

export const AvatarMenu = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const handleSelect = (key: string) => {
    switch (key) {
      case 'myApp':
        history.push('/workbench/apps');
        break;
      case 'profile':
        history.push('/user/profile');
        break;
      case 'coupons':
        history.push('/user/coupons');
        break;
      case 'resourceManage':
        history.push('/resource-manage');
        break;
      case 'expense':
        history.push('/expense');
        break;
      case 'token':
        history.push('/user/token');
        break;
      default:
        userImplement.logout();
        break;
    }
  };

  const menu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myApp">
        {t('我的产品')}
      </Menu.Item>
      <Menu.Item key="profile">
        {t('个人信息')}
      </Menu.Item>
      {(!ENV.isOverseas) && <Menu.Item key="expense">
        {t('订单管理')}
      </Menu.Item>}
      <Menu.Item key="resourceManage">
        {t('资源包')}
      </Menu.Item>
      <Menu.Item key="token">
        {t('个人令牌')}
      </Menu.Item>
      <Menu.Item key="logout">
        {t('退出登录')}
      </Menu.Item>
    </Menu>
  );

  return <Dropdown overlay={menu} placement={'bottomRight'}>
    <Avatar style={{ marginBottom: '5px' }} size={28} src={userImplement.getAvatar()} />
  </Dropdown>;
};
